import {AxiosResponse} from "@twigsby/client-data";
import {AlertBanner, ColourSolid} from "@twigsby/frontend-framework";
import {useTranslation} from "@twigsby/frontend-framework";

type ErrorMapperType = {
    errorResponse: AxiosResponse;
    title?: string;
}
const ErrorMapper = (props: ErrorMapperType) => {
    const{ t } = useTranslation();

    if(props.errorResponse.data?.message || props.errorResponse.data?.error) {
        return (
            <ErrorGenericMessage title={props.title} errorResponse={props.errorResponse} />
        )
    }

    if(props.errorResponse.data) {
        return (
            <ErrorValidationObject title={props.title} errorResponse={props.errorResponse} />
        )
    }

    return (
        <AlertBanner
            colourMod={ColourSolid.Alert}
            title={props.title || `${t('status.error')} ${props.errorResponse.status.toString()}`}
            content={<p>{props.errorResponse.statusText}</p>}
        />
    )
}

const ErrorValidationObject = (props: ErrorMapperType) => {
    const{ t } = useTranslation();

    return (
        <AlertBanner
            colourMod={ColourSolid.Alert}
            title={props.title || `${t('status.error')} ${props.errorResponse.status.toString()}`}
            content={
                <ul>
                    {Object.entries(props.errorResponse.data).map(([k, v], index) =>
                        <li>{props.errorResponse.data[k].toString()}</li>
                    )}
                </ul>
            }
        />
    )
}

type ExampleErrorDataType = {
    [key: string]: any;
    error: ErrorResponseType;
}

type ErrorResponseType = {
    message: string;
    cause?: Record<string, unknown>;
}

const exampleDate: ExampleErrorDataType = {
    error: {
        message: 'The form has validation errors and can not be saved',
        cause: {
            "EmailAddress": [
                "The specified condition was not met for 'Email Address'."
            ],
            "Subject": [
                "'Subject' must not be empty."
            ],
            "RecipientName": [
                "'Recipient Name' must not be empty."
            ],
            "ClientName": [
                "'Client Name' must not be empty."
            ],
        }
    },
}

const ErrorGenericMessage = (props: ErrorMapperType) => {
    const{ t } = useTranslation();

    return (
        <AlertBanner
            colourMod={ColourSolid.Alert}
            title={props.title || `${t('status.error')} ${props.errorResponse.status.toString()}`}
            content={<p>{props.errorResponse.data.message ? props.errorResponse.data.message : props.errorResponse.data.error}</p>}
        />
    )
}

export { ErrorMapper, ErrorValidationObject, ErrorGenericMessage }
